<template>
  <div class="container bg-white" id="harga">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('tos.harga.title') }}</h3>
        <div class="divider"></div>
        <ol>
          <li>{{ $t('tos.harga.line1') }}</li>
          <li>{{ $t('tos.harga.line2') }}</li>
          <li>{{ $t('tos.harga.line3') }}</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'definisi',
};
</script>
